import api from '@pray/shared/utils/api';

import { mapSolomonInsights } from './mappers';
import type { GetSolomonInsightsResponse } from './types';

type GetSolomonInsightsProps = {
  artistId: string;
  articleId: string;
};

export async function getSolomonInsights({ artistId, articleId }: GetSolomonInsightsProps) {
  if (!artistId) throw Error('Artist ID is required');
  if (!articleId) throw Error('Article ID is required');

  const params = {
    property: 'solomon_insights',
  };

  const url = `/web/studio/artists/${artistId}/articles/${articleId}/suggestions`;
  const response = await api.executeGetRequest<GetSolomonInsightsResponse>(url, params);

  const insights = mapSolomonInsights(response.data.data?.insights);

  return {
    insights,
  };
}
